<ng-container *transloco="let t; read: 'user'">
<div class="fix-action-row modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ t('dashboard.pendingRequests.declineRelease.title') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid grid-cols-2 gap-x-10" [formGroup]="declineReleaseStudentForm">

      <div class="col-span-full md:col-span-1 pt-3">
        <label class="font-normal" for="Name">{{ t('dashboard.pendingRequests.declineRelease.childName') }}</label>
        <p>{{child.studentName}}</p>
      </div>

      <div class="col-span-full md:col-span-1 pt-4">
        <mat-form-field class="example-full-width no-underline" appearance="fill">
          <label class="font-normal">{{ t('dashboard.pendingRequests.declineRelease.reasonLabel') }}<span class="required"></span></label>
          <mat-select formControlName="classDeclineReleaseReasonId" [placeholder]="t('dashboard.pendingRequests.declineRelease.reasonPlaceholder')">
            @for (reason of declineReleaseReasons$ | async; track reason) {
              <!-- Server-supplied decline release reason. -->
              <mat-option [value]="reason.id"
              (click)="getSelectedDeclineReleaseReason(reason)"> {{ reason.declineReleaseReason }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (isOther) {
        <div class="col-span-full">
          <mat-form-field class="bg-white" appearance="fill">
            <label class="font-normal" for="comment">{{ t('dashboard.pendingRequests.declineRelease.commentLabel') }}</label>
            <input matInput [placeholder]="t('dashboard.pendingRequests.declineRelease.commentPlaceholder')" autocomplete="off" type="text" formControlName="comment">
          </mat-form-field>
        </div>
      }

    </form>

  </div>
</div>
<div mat-dialog-actions class="flex justify-end pt-4">
  <drdp-btn color="cancel" mat-button mat-dialog-close>{{ t('dashboard.pendingRequests.actions.cancel') }}</drdp-btn>
  <drdp-btn class="ml-3" mat-button [disabled]="declineReleaseStudentForm.invalid" cdkFocusInitial (click)="onSubmit()">{{ t('dashboard.pendingRequests.actions.save') }}</drdp-btn>
</div>
</ng-container>